<template>
  <owal-button
    class="add-detectable-button"
    style="margin: 0.5rem .5rem .0rem 0;"
    :tooltip="tooltip"
    tooltipDirection='right'
    @click="$emit('click')"
    >
    <font-awesome-icon
      :icon="icon"
      size="lg"
      style="color: rgba(168, 168, 168, 1)"
      />
  </owal-button>
</template>

<script>
import OwalButton from '../buttons/OwalButton'

export default {
  name: 'FormGroupbutton',
  components: {
    OwalButton,
  },
  props: ['icon', 'tooltip'],
  data () {
    return {
      editing: false,
    }
  },
}
</script>

<style>

</style>
